import UIkit from 'uikit';

const body = document.querySelector("body");

function pageLinksHandler(e) {
    var dataAttr = "data-filter";
    var el_link = e.target.closest("a");

    if (el_link && el_link.hasAttribute(dataAttr)) {
        var filtersID = el_link.getAttribute(dataAttr);

        var activeFilter = document
            .querySelector(filtersID)
            .querySelector(".uk-active .link-filter-title");

        el_link.href = `${el_link.getAttribute("href")}?filter=${
            activeFilter.textContent
        }`;
    }
}

export default {
    init: function () {
        //Filters pagination
        if (document.querySelectorAll("[class^='blocklink']").length > 0) {
            body.addEventListener("mousedown", pageLinksHandler);
        }
    },
    cleanup: function () {
        body.removeEventListener("mousedown", pageLinksHandler);
    }
};


// Function to remove ARIA roles from slider <li> elements
function handleSliderARIA() {
    function removeRoleFromSliderItems() {
        const sliderItems = document.querySelectorAll('.uk-slideshow-items li');
        sliderItems.forEach(function (item) {
            if (item.hasAttribute('role')) {
                item.removeAttribute('role');
            }
        });
    }

    // Remove roles initially
    removeRoleFromSliderItems();

    // Add event listener for the UIkit slider itemshow event
    const sliderElement = document.querySelector('[uk-slideshow]');
    if (sliderElement) {
        UIkit.util.on(sliderElement, 'itemshow', () => {
            removeRoleFromSliderItems(); 
        });
    }
  }


// Initialize filters and links on document ready
document.addEventListener('DOMContentLoaded', () => {
    handleSliderARIA();
});
